import axios from 'axios';
import { getDomainOrigin } from '@utils/serverConfig';

export function fetchUserDetails(setUserDetails: Function) {
    const view = new URL(window.location.href)?.searchParams?.get('view');
    if (view === 'iframe') {
        localStorage.setItem('view', 'iframe');
    }
    axios
        .get(`${getDomainOrigin()}/api/user/details/`, {
            withCredentials: true,
        })
        .then((res) => {
            setUserDetails(res?.data);
        })
        .catch((err) => {
            console.log('Failed to load user details : ', err);
        });
}
